import { AccountListItem } from "../../../types";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { isTextEllipsed } from "../../../utils/general_utils";
import { indicatorMapper, RateIndicatorIcon } from "../../ui/RateIndicatorIcon";

export const EngagementScoreCell = ({ row }: { row: AccountListItem }) => {
  if (row.total_engagement_score === null) return null;

  const { indicator, score, change, changed_at } = row.engagement;
  const totalEngagementScore = score || 0;
  return (
    <Stack
      alignItems="center"
      onMouseEnter={(event: React.MouseEvent<HTMLDivElement>) =>
        isTextEllipsed(event.currentTarget)
      }
    >
      <Stack alignItems="center">
        <Stack
          sx={{ position: "relative", width: "42px", height: "42px" }}
          justifyContent="center"
        >
          <Stack
            sx={{
              position: "absolute",
              left: -26,
              top: 10,
              zIndex: 2,
            }}
          >
            <RateIndicatorIcon
              indicatorRate={indicator}
              indicatorChangeAt={changed_at}
              indicatorChange={change}
            />
          </Stack>
          <CircularProgress
            size={42}
            thickness={4}
            variant="determinate"
            sx={{
              color: "#D4D4D4",
              position: "absolute",
              left: 0,
              top: 0,
              zIndex: 1,
              opacity: 1,
            }}
            value={100}
          />
          <CircularProgress
            size={42}
            thickness={4}
            variant="determinate"
            sx={{
              color: "#3279B3",
              position: "absolute",
              left: 0,
              top: 0,
              zIndex: 2,
              opacity: 1,
            }}
            value={totalEngagementScore}
          />
          <Typography
            variant="body1"
            align="center"
            sx={{
              flexShrink: 1,
              fontSize: 10,
              fontWeight: 600,

              ...(indicator && {
                color: indicatorMapper[indicator].color,
              }),
            }}
          >
            {totalEngagementScore}%
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
